{
	"altLogo": "Logo",
	"ariaAIStyleAlreadyInUse": "AI Style Already In Use",
	"createdOn": "Created on {{var0}}",
	"inUse": "AI Style in use",
	"usingReferenceImages": "Using {{var0}} Reference Images"
}
